module.exports = __webpack_public_path__ + "media/media/cases/cases-step-2-9ef6c338628b28c9b8352e788cb6e690.jpg";